import { provideWidgetClass } from 'scrivito'

export const DividerWidget = provideWidgetClass('DividerWidget', {})
